<template>
  <v-card class="ma-0 pa-4 wrapper">
    <v-row class="pa-0 ma-0">
      <v-col cols="12" md="3" class="ps-0 py-0">
        <v-container class="pa-0 products-list">
          <div class="header">
            <div class="d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-1 mt-2">{{
                $t("products")
              }}</v-card-text>
              <div class="d-flex gap-2">
                <v-text-field
                  v-model="search"
                  height="20"
                  dense
                  outlined
                  class="dense search"
                  clearable
                  :label="$t('search')"
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      @click="openUploadDialog"
                      custom
                      color="error"
                      style="height: 34px !important; padding: 5px 7px !important"
                    >
                      <v-icon size="20">mdi-database-import-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("importData") }}</span>
                </v-tooltip>
                <v-btn
                  outlined
                  custom
                  color="primary"
                  style="height: 34px !important; padding: 5px 7px !important"
                  @click="searchInvDialog = true"
                >
                  <v-icon size="18">mdi-plus</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="d-flex justify-space-between align-center mt-2">
              <v-checkbox v-model="allSelected" class="mt-0" @change="toggleSelectAll" />
              <div class="d-flex align-center gap-2">
                <v-btn
                  color="secondary"
                  outlined
                  @click="openCalculator"
                  class="calculator"
                >
                  <my-icon
                    :name="'calculator'"
                    :width="25"
                    :height="25"
                    :cursorPointer="true"
                  />
                </v-btn>
                <v-container class="wrapper-toggle d-flex pa-0 ma-0" style="width: 151px">
                  <div
                    v-for="(item, index) in stockStatus"
                    :key="index"
                    @click="selectStockStatus(item)"
                    class="child flex-fill text-center"
                    :style="{
                      'background-color':
                        selectedStockStatus == item.value ? '#0066ff' : '',
                      'border-color':
                        selectedStockStatus == item.value ? '#0066ff' : 'silver',
                      color: selectedStockStatus == item.value ? '#fff' : '',
                    }"
                  >
                    <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                  </div>
                </v-container>
              </div>
            </div>
          </div>
          <div
            v-if="products != null && products != undefined"
            class="wrapper d-flex flex-column mt-2 gap-2"
          >
            <div
              v-for="(product, index) in filteredProducts"
              :key="index"
              class="products-item d-flex gap-2 py-2"
              :style="{
                'background-color':
                  product.productStock < 0 ? 'rgba(255, 0, 0, 0.1)' : '',
                'border-radius': product.productStock < 0 ? '5px' : '',
              }"
            >
              <v-checkbox
                v-model="product.selected"
                class="mt-2 custom-checkbox"
                @change="toggleProductSelection(product)"
              />
              <img
                :src="
                  product.avatar != null && product.avatar.link != null
                    ? product.avatar.link
                    : require('@/assets/imagePlacholder.png')
                "
              />
              <div class="flex-grow-1" style="flex: 1 1 auto; min-width: 0; width: 100%">
                <v-card-text
                  class="pa-0 text-body-2 truncate d-block"
                  style="width: 100% !important"
                >
                  {{
                    product.name
                      ? product.name
                      : product["3"]
                      ? product["3"]
                      : $t("haveNot")
                  }}
                </v-card-text>
                <v-card-text class="pa-0 text-body-2">
                  {{
                    product.price
                      ? $numberFormat(parseFloat(product.price))
                      : product["18"]
                      ? $numberFormat(parseFloat(product["18"]))
                      : $t("haveNot")
                  }}
                  {{ $store.state.currencySymbol }}
                </v-card-text>
              </div>
              <v-text-field
                v-model.number="product.productStock"
                type="number"
                outlined
                height="38"
                hide-spin-buttons
                dense
                class="count"
              />
              <v-icon size="20" color="error" @click="removeProduct(index)">
                mdi-close
              </v-icon>
            </div>
          </div>
        </v-container>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-container class="pa-0 wrapper-printer">
          <div
            v-if="products.some((p) => Number(p.productStock) > 0)"
            id="print"
            class="d-flex justify-center"
          >
            <div
              class="main-paper"
              :style="{
                width: paperWidth ? paperWidth + 'mm' : null,
                height:
                  paperHeight && (paperSize == 'a4' || paperSize == 'a5')
                    ? paperHeight + 'mm'
                    : null,
                'padding-top': spaceTop ? spaceTop + 'mm' : null,
                'padding-right': spaceRight ? spaceRight + 'mm' : null,
                'padding-bottom': spaceBottom ? spaceBottom + 'mm' : null,
                'padding-left': spaceLeft ? spaceLeft + 'mm' : null,
              }"
            >
              <div
                class="flex-wrapper"
                :style="{
                  'column-gap': gapXBetweenLabels ? gapXBetweenLabels + 'mm' : null,
                  'row-gap': gapYBetweenLabels ? gapYBetweenLabels + 'mm' : null,
                }"
              >
                <div
                  v-for="(item, i) in expandedProducts"
                  :key="i"
                  class="flex-item"
                  :style="{
                    width: gapXBetweenLabels
                      ? 'calc((100% - (' +
                        gapXBetweenLabels +
                        'mm * (' +
                        (columnCount - 1) +
                        '))) / ' +
                        columnCount +
                        ')'
                      : 'calc(100% / ' + columnCount + ')',
                    height: labelHeight ? labelHeight + 'mm' : null,
                    gap: gapBetweenLabelInfo ? gapBetweenLabelInfo + 'mm' : null,
                    'padding-top': spaceInsideTop ? spaceInsideTop + 'mm' : null,
                    'padding-right': spaceInsideRight ? spaceInsideRight + 'mm' : null,
                    'padding-bottom': spaceInsideBottom ? spaceInsideBottom + 'mm' : null,
                    'padding-left': spaceInsideLeft ? spaceInsideLeft + 'mm' : null,
                  }"
                >
                  <img
                    v-if="
                      barcodeOption === 'barcode' &&
                      barcodeActive &&
                      barcodeGenerateWith(item)
                    "
                    :key="codeOption + '::' + barcodeGenerateWith(item)"
                    class="barcode"
                    :width="barcodeWidth + 'mm'"
                    :height="barcodeHeight + 'mm'"
                    :jsbarcode-value="barcodeGenerateWith(item)"
                    jsbarcode-displayvalue="false"
                    jsbarcode-textmargin="0"
                    jsbarcode-background="transparent"
                    jsbarcode-fontoptions="bold"
                  />
                  <div class="d-flex justify-center">
                    <div
                      v-show="
                        barcodeOption == 'QRcode' &&
                        barcodeGenerateWith(item) &&
                        barcodeActive
                      "
                      :id="`qrcode-${item.id}-${i}`"
                      :key="`${item.id}-${i}`"
                      class="qrcode"
                      :style="{
                        width: barcodeWidth + 'mm',
                        height: barcodeHeight + 'mm',
                      }"
                    ></div>
                  </div>
                  <span
                    v-if="codeOption != null && selectedOptionCode"
                    class="text-label"
                    :style="{
                      textAlign: 'center',
                      fontSize: (textSizeProductCode || 8) + 'pt',
                    }"
                  >
                    {{ barcodeGenerateWith(item) }}
                  </span>
                  <span
                    v-if="(item.name || item['3']) && selectedOptionName"
                    class="text-label"
                    :style="{
                      fontSize: (textSizeNameProduct || 8) + 'pt',
                      'white-space': selectedNameVisual == 'active' ? 'normal' : 'nowrap',
                      overflow: selectedNameVisual == 'active' ? 'visible' : 'hidden',
                      'text-overflow':
                        selectedNameVisual == 'active' ? 'normal' : 'ellipsis',
                    }"
                    style="text-align: center"
                  >
                    {{ item.name ? item.name : item["3"] ? item["3"] : $t("haveNot") }}
                  </span>
                  <span
                    v-if="(item.price || item['18']) && selectedOptionPrice"
                    class="text-label"
                    :style="{
                      textAlign: 'center',
                      fontSize: (textSizeProductPrice || 8) + 'pt',
                    }"
                  >
                    {{
                      item.price
                        ? $numberFormat(parseFloat(item.price))
                        : item["18"]
                        ? $numberFormat(parseFloat(item["18"]))
                        : $t("haveNot")
                    }}
                    {{ $store.state.currencySymbol }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-col>
      <v-col cols="12" md="3" class="py-0 pe-0">
        <v-container class="pa-0 wrapper-setting">
          <v-card-text class="pa-0 text-body-1">{{ $t("label-setting") }}</v-card-text>
          <v-card-text class="pa-0 text-body-2 mt-4 mb-3">{{
            $t("paper-setting")
          }}</v-card-text>
          <v-select
            v-model="paperSize"
            :items="paperSizes"
            dense
            class="mt-2"
            outlined
            height="20"
            hide-details
            item-value="value"
            item-text="label"
            :label="$t('paper-size')"
            @change="handlePaperSizeChange"
          />
          <div class="d-flex justify-space-between mt-6">
            <v-card-text class="pa-0 text-body-2 mt-2">{{ $t("widthRoll") }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="paperWidth"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <div class="d-flex justify-space-between mt-4">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("count-of-column-in-page")
            }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input without-unit"
                v-model.number="columnCount"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              />
            </div>
          </div>
          <div class="d-flex justify-space-between mt-4">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("space-between-labels")
            }}</v-card-text>
            <div class="d-flex gap-4">
              <v-text-field
                class="setting-input has-unit"
                v-model.number="gapYBetweenLabels"
                min="1"
                type="number"
                outlined
                height="20"
                :placeholder="$t('rows')"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="gapXBetweenLabels"
                min="1"
                type="number"
                outlined
                :placeholder="$t('column')"
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <div class="d-flex align-end gap-2 mt-2">
            <v-card-text class="pa-0 text-body-2 mt-4"
              >{{ $t("all-sides-space") }} {{ $t("paper") }}</v-card-text
            >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-card-text
                  class="pa-0 text-caption text-primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="text-primary">mm</span>
                  <v-icon size="15" color="primary">mdi-menu-down</v-icon>
                </v-card-text>
              </template>
              <!-- <v-list>
                                <v-list-item>
                                    <v-list-item-title>mm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>cm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>inch</v-list-item-title>
                                </v-list-item>
                            </v-list> -->
            </v-menu>
          </div>
          <div class="d-flex align-center justify-space-between mt-2">
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceLeft"
                min="1"
                type="number"
                outlined
                :placeholder="$t('left')"
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceBottom"
                min="1"
                type="number"
                outlined
                :placeholder="$t('bottom')"
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceRight"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                :placeholder="$t('right')"
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceTop"
                min="1"
                type="number"
                outlined
                :placeholder="$t('top')"
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <v-card-text class="pa-0 text-body-1 mt-10">{{
            $t("label-setting")
          }}</v-card-text>
          <div class="d-flex justify-space-between mt-3">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("labels-height")
            }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="labelHeight"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <div class="d-flex justify-space-between mt-4">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("labels-width")
            }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="labelWidth"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <div class="d-flex justify-space-between mt-4">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("distance-between-labels-info")
            }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="gapBetweenLabelInfo"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <!-- <div class="d-flex justify-space-between mt-4">
            <v-card-text class="pa-0 text-body-2 mt-2">{{ $t("text-size") }}</v-card-text>
            <div>
              <v-text-field
                class="setting-input has-unit"
                v-model.number="textSizeNameProduct"
                min="1"
                type="number"
                outlined
                height="20"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">pt</span>
                </template>
              </v-text-field>
            </div>
          </div> -->
          <div class="d-flex align-end gap-2">
            <v-card-text class="pa-0 text-body-2 mt-4"
              >{{ $t("all-sides-space") }} {{ $t("label") }}</v-card-text
            >
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-card-text
                  class="pa-0 text-caption text-primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="text-primary">mm</span>
                  <v-icon size="15" color="primary">mdi-menu-down</v-icon>
                </v-card-text>
              </template>
              <!-- <v-list>
                                <v-list-item>
                                    <v-list-item-title>mm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>cm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>inch</v-list-item-title>
                                </v-list-item>
                            </v-list> -->
            </v-menu>
          </div>
          <div class="d-flex align-center justify-space-between mt-2">
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceInsideLeft"
                min="1"
                type="number"
                outlined
                height="20"
                :placeholder="$t('left')"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceInsideBottom"
                min="1"
                type="number"
                outlined
                height="20"
                :placeholder="$t('bottom')"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceInsideRight"
                min="1"
                type="number"
                outlined
                height="20"
                :placeholder="$t('right')"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
            <div>
              <v-text-field
                class="setting-input has-unit distance"
                v-model.number="spaceInsideTop"
                min="1"
                type="number"
                outlined
                height="20"
                :placeholder="$t('top')"
                hide-spin-buttons
                dense
              >
                <template v-slot:prepend-inner>
                  <span class="text-caption grey--text">mm</span>
                </template>
              </v-text-field>
            </div>
          </div>
          <v-card-text class="pa-0 text-body-1 mt-10">{{
            $t("label-content")
          }}</v-card-text>
          <div class="d-flex align-center mt-2">
            <v-checkbox v-model="barcodeActive" class="mt-0" />
            <v-card-text class="pa-0 text-body-2 ml-2">{{
              $t("barcode or QRcode")
            }}</v-card-text>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-card-text
                  class="pa-0 text-caption text-primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="text-primary">mm</span>
                  <v-icon size="15" color="primary">mdi-menu-down</v-icon>
                </v-card-text>
              </template>
              <!-- <v-list>
                                <v-list-item>
                                    <v-list-item-title>mm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>cm</v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>inch</v-list-item-title>
                                </v-list-item>
                            </v-list> -->
            </v-menu>
          </div>
          <div class="d-flex justify-space-between mt-2">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("create-barcode-with")
            }}</v-card-text>
            <div>
              <v-select
                v-model="codeOption"
                :items="codeOptions"
                dense
                outlined
                class="code-option"
                height="20"
                :disabled="!barcodeActive"
                hide-details
                item-value="value"
                item-text="label"
                :label="$t('id-code-barcode')"
              />
            </div>
          </div>
          <div class="d-flex align-center justify-space-between mt-5 gap-3">
            <v-select
              v-model="barcodeOption"
              :items="barcodeOptions"
              dense
              outlined
              height="20"
              :disabled="!barcodeActive"
              hide-details
              item-value="value"
              item-text="label"
              :label="$t('barcode or QRcode')"
            />
            <v-text-field
              class="setting-input has-unit distance"
              v-model.number="barcodeHeight"
              min="1"
              type="number"
              outlined
              :disabled="!barcodeActive"
              :placeholder="$t('height')"
              height="20"
              hide-spin-buttons
              dense
            >
              <template v-slot:prepend-inner>
                <span class="text-caption grey--text">mm</span>
              </template>
            </v-text-field>
            <v-text-field
              class="setting-input has-unit distance"
              v-model.number="barcodeWidth"
              min="1"
              type="number"
              outlined
              :disabled="!barcodeActive"
              :placeholder="$t('width')"
              height="20"
              hide-spin-buttons
              dense
            >
              <template v-slot:prepend-inner>
                <span class="text-caption grey--text">mm</span>
              </template>
            </v-text-field>
          </div>
          <div class="d-flex justify-space-between align-center mt-6">
            <v-card-text class="pa-0 text-body-2">{{
              $t("showing-product-price")
            }}</v-card-text>
            <div class="d-flex align-center show-price-controls" style="gap: 2px">
              <div>
                <v-text-field
                  class="setting-input has-unit show-price-font-input"
                  v-model.number="textSizeProductPrice"
                  min="1"
                  type="number"
                  outlined
                  height="20"
                  hide-spin-buttons
                  dense
                >
                  <template v-slot:prepend-inner>
                    <span class="text-caption grey--text">pt</span>
                  </template>
                </v-text-field>
              </div>
              <v-container
                class="wrapper-toggle show-price-toggle d-flex pa-0 ma-0"
                style="width: 100px"
              >
                <div
                  v-for="(item, index) in globalOptions"
                  :key="index"
                  @click="selectOptionPrice(item)"
                  class="child flex-fill text-center"
                  :style="{
                    'background-color':
                      selectedOptionPrice == item.value ? '#0066ff' : '',
                    'border-color':
                      selectedOptionPrice == item.value ? '#0066ff' : 'silver',
                    color: selectedOptionPrice == item.value ? '#fff' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                </div>
              </v-container>
            </div>
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <v-card-text class="pa-0 text-body-2">{{
              $t("showing-product-name")
            }}</v-card-text>
            <div class="d-flex align-center show-name-controls" style="gap: 2px">
              <div>
                <v-text-field
                  class="setting-input has-unit show-name-font-input"
                  v-model.number="textSizeNameProduct"
                  min="1"
                  type="number"
                  outlined
                  height="20"
                  hide-spin-buttons
                  dense
                >
                  <template v-slot:prepend-inner>
                    <span class="text-caption grey--text">pt</span>
                  </template>
                </v-text-field>
              </div>
              <v-container
                class="wrapper-toggle show-name-toggle d-flex pa-0 ma-0"
                style="width: 100px"
              >
                <div
                  v-for="(item, index) in globalOptions"
                  :key="index"
                  @click="selectOptionName(item)"
                  class="child flex-fill text-center"
                  :style="{
                    'background-color': selectedOptionName == item.value ? '#0066ff' : '',
                    'border-color':
                      selectedOptionName == item.value ? '#0066ff' : 'silver',
                    color: selectedOptionName == item.value ? '#fff' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                </div>
              </v-container>
            </div>
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <v-card-text class="pa-0 text-body-2">{{
              $t("showing-product-code")
            }}</v-card-text>
            <div class="d-flex align-center show-code-controls" style="gap: 2px">
              <div>
                <v-text-field
                  class="setting-input has-unit show-code-font-input"
                  v-model.number="textSizeProductCode"
                  min="1"
                  type="number"
                  outlined
                  height="20"
                  hide-spin-buttons
                  dense
                >
                  <template v-slot:prepend-inner>
                    <span class="text-caption grey--text">pt</span>
                  </template>
                </v-text-field>
              </div>
              <v-container
                class="wrapper-toggle show-code-toggle d-flex pa-0 ma-0"
                style="width: 100px"
              >
                <div
                  v-for="(item, index) in globalOptions"
                  :key="index"
                  @click="selectOptionCode(item)"
                  class="child flex-fill text-center"
                  :style="{
                    'background-color': selectedOptionCode == item.value ? '#0066ff' : '',
                    'border-color':
                      selectedOptionCode == item.value ? '#0066ff' : 'silver',
                    color: selectedOptionCode == item.value ? '#fff' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                </div>
              </v-container>
            </div>
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <v-card-text class="pa-0 text-body-2">{{
              $t("showing product name completly")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle show-code-toggle d-flex pa-0 ma-0"
              style="width: 100px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectNameVisual(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedNameVisual == item.value ? '#0066ff' : '',
                  'border-color': selectedNameVisual == item.value ? '#0066ff' : 'silver',
                  color: selectedNameVisual == item.value ? '#fff' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <v-container class="pa-4 footer">
      <div class="d-flex justify-space-between align-center w-100">
        <div class="d-flex align-center gap-3">
          <v-card-text class="pa-0 text-body-2">
            <span style="color: #6e6969">{{ $t("count-of-all-products") }} : </span>
            {{ products.length }}
          </v-card-text>
          <v-card-text class="pa-0 text-body-2">
            <span style="color: #6e6969">{{ $t("count-of-all-labels") }} : </span>
            {{ expandedProducts.length }}
          </v-card-text>
        </div>
        <v-btn color="primary" height="35" @click="print">
          <span class="ml-1">{{ $t("print") }}</span>
          <v-icon size="15">mdi-printer-outline</v-icon>
        </v-btn>
      </div>
    </v-container>
    <ProductSearch
      :isDialogVisible="searchInvDialog"
      @searchInvClosed="searchInvDialog = false"
      :typeForm="'product'"
      @onSelectedRow="selectRowHandler"
    />
    <!--calculator-->
    <v-dialog v-model="calcDialog" width="360">
      <v-card class="pa-4" style="height: auto">
        <v-container
          style="border-bottom: 1px solid silver"
          class="pa-0 pb-3 ma-0 mb-6 d-flex align-center justify-space-between"
        >
          <v-card-text class="pa-0 text-body-1">{{
            $t("print-count-setting")
          }}</v-card-text>
          <v-icon
            color="error"
            size="15"
            style="cursor: pointer"
            @click="calcDialog = false"
          >
            mdi-close
          </v-icon>
        </v-container>
        <v-text-field
          v-model="formula"
          height="20"
          dense
          outlined
          class="dense w-100"
          clearable
          :label="$t('print-formula')"
        />
        <div class="d-flex align-center mt-6 gap-2">
          <v-icon size="15" color="primary">mdi-alert-circle-outline</v-icon>
          <v-card-text class="pa-0 text-body-2">{{
            $t("you can use these operation in formula box")
          }}</v-card-text>
        </div>
        <div class="d-flex align-center gap-2 mt-4" style="height: 17.5px">
          <v-icon v-if="formulaError" size="15" color="error">mdi-alert</v-icon>
          <v-card-text
            style="color: #ff5252"
            class="pa-0 text-body-2"
            v-if="formulaError"
          >
            {{ $t(formulaError) }}
          </v-card-text>
        </div>
        <div
          style="border-top: 1px solid silver"
          class="d-flex align-center justify-space-between pt-2 mt-5"
        >
          <v-btn color="primary" height="33" @click="performFormula">
            {{ $t("perform-formula") }}
          </v-btn>
          <v-card-text class="pa-0 text-caption">
            {{ $t("selected-items-count") }} :
            {{ selectedProducts.length }}
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <!--permission-->
    <v-dialog
      v-model="askPermissionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="300"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="65" color="error">mdi-alert-circle-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 text-center my-3">
          {{ $t("you should first choose some items") }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--excel-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="barcode"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
            @input="getItems"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      :timeout="20000"
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import ProductSearch from "@/views/dashboard/pages/product/partial/ProductSearch.vue";
import Upload from "@/views/dashboard/components/general/upload/upload.vue";

export default {
  name: "Barcode",
  data() {
    return {
      products: [],
      selectedStockStatus: "stock",
      selectedProducts: [],
      allSelected: false,
      searchInvDialog: false,
      search: null,
      filteredProducts: [],
      calcDialog: false,
      formula: null,
      askPermissionDialog: false,
      formulaError: null,

      paperSize: null,
      paperWidth: null, // check
      paperHeight: null, // check
      gapYBetweenLabels: null, // check
      gapXBetweenLabels: null, // check
      columnCount: null, // check
      spaceTop: null, // check
      spaceRight: null, // check
      spaceBottom: null, // check
      spaceLeft: null, // check
      labelHeight: null, // check
      labelWidth: null, // check
      gapBetweenLabelInfo: null, // check
      textSizeNameProduct: 8,
      textSizeProductPrice: 8,
      textSizeProductCode: 8,
      spaceInsideLeft: null, // check
      spaceInsideBottom: null, // check
      spaceInsideRight: null, // check
      spaceInsideTop: null, // check
      barcodeActive: false,
      barcodeOption: null,
      barcodeHeight: null, // check
      barcodeWidth: null, // check
      selectedOptionPrice: true,
      selectedOptionName: true,
      selectedOptionCode: true,
      hydratingItems: false,
      codeOption: null,
      selectedNameVisual: "deactive",
      qrcode: null,
      uploadDialog: false,
      snakbar: false,
      snakbarColor: null,
      snakbarText: null,
    };
  },
  components: {
    MyIcon,
    ProductSearch,
    Upload,
  },
  computed: {
    stockStatus() {
      return [
        { label: this.$t("stock"), value: "stock" },
        { label: this.$t("optional"), value: "optional" },
      ];
    },
    paperSizes() {
      return [
        { label: this.$t("A4-paper"), value: "a4" },
        { label: this.$t("A5-paper"), value: "a5" },
        { label: this.$t("role-paper-4inch1inch"), value: "role" },
        { label: this.$t("custom"), value: "custom" },
      ];
    },
    barcodeOptions() {
      return [
        { label: this.$t("barcode"), value: "barcode" },
        { label: this.$t("QRcode"), value: "QRcode" },
      ];
    },
    codeOptions() {
      return [
        { label: this.$t("product-id"), value: "withId" },
        { label: this.$t("product-code"), value: "withCode" },
        { label: this.$t("product-barcode"), value: "withBarcode" },
      ];
    },
    globalOptions() {
      return [
        { label: this.$t("has"), value: true },
        { label: this.$t("haveNot"), value: false },
      ];
    },
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    expandedProducts() {
      const list = [];
      this.products.forEach((product) => {
        const count = parseInt(product.productStock) || parseInt(product["15"]) || 0;
        for (let i = 0; i < count; i++) {
          list.push(product);
        }
      });
      return list;
    },
  },
  methods: {
    selectStockStatus(item) {
      this.selectedStockStatus = item.value;
    },
    selectOptionPrice(item) {
      this.selectedOptionPrice = item.value;
    },
    selectOptionName(item) {
      this.selectedOptionName = item.value;
    },
    selectOptionCode(item) {
      this.selectedOptionCode = item.value;
    },
    selectNameVisual(item) {
      this.selectedNameVisual = item.value;
    },
    resolveStockValue(product) {
      if (this.selectedStockStatus == "stock") {
        if (product.stock == null || product.stock == undefined) {
          if (product.count) {
            return product.count;
          } else {
            return 0;
          }
        }
        if (product.bundle == null || product.bundle == undefined) {
          if (product.stock) {
            return product.stock.count;
          } else {
            return 0;
          }
        } else {
          if (product.stockBundle) {
            return product.stockBundle.count;
          } else {
            return 0;
          }
        }
      } else {
        return null;
      }
    },
    removeProduct(index) {
      this.products.splice(index, 1);
      this.filteredProducts = [...this.products];
    },
    toggleProductSelection(product) {
      if (product.selected) {
        if (!this.selectedProducts.includes(product)) {
          this.selectedProducts.push(product);
        }
      } else {
        const unSelectedIndex = this.selectedProducts.findIndex(
          (p) => p.id == product.id
        );
        this.selectedProducts.splice(unSelectedIndex, 1);
        this.allSelected = false;
      }
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.products.forEach((product) => {
          product.selected = true;
        });
        this.selectedProducts = [...this.products];
      } else {
        this.products.forEach((product) => {
          product.selected = false;
        });
        this.selectedProducts = [];
      }
    },
    selectRowHandler(selectedRow) {
      selectedRow.productStock = this.resolveStockValue(selectedRow);
      this.products.push(selectedRow);
      this.filteredProducts = [...this.products];
      this.searchInvDialog = false;
    },
    openCalculator() {
      if (this.selectedProducts.length > 0) {
        this.calcDialog = true;
      } else {
        this.askPermissionDialog = true;
      }
    },
    performFormula() {
      const cmd = this.formula.trim();
      if (!cmd) return;

      const match = cmd.match(/^([+\-*/=])\s*(-?\d+(\.\d+)?)$/);
      if (!match) {
        this.formulaError = "invalid-character";
        return;
      }

      const operator = match[1];
      const number = parseFloat(match[2]);

      this.selectedProducts.forEach((p) => {
        const stock = p.productStock || 0;
        switch (operator) {
          case "+":
            p.productStock = stock + number;
            break;
          case "-":
            p.productStock = stock - number;
            break;
          case "*":
            p.productStock = stock * number;
            break;
          case "/":
            p.productStock = stock / number;
            break;
          case "=":
            p.productStock = number;
            break;
        }
      });
      this.calcDialog = false;
      this.formula = "";
    },
    barcodeGenerate() {
      if (!window.JsBarcode) return console.error("JsBarcode not found yet");
      this.$nextTick(() => {
        window.JsBarcode(".barcode").options({ displayValue: true }).init();
      });
    },
    QRCodeGenerate() {
      if (!window.QRCode) {
        console.error("QRCode library not loaded");
        return;
      }

      this.expandedProducts.forEach((item, i) => {
        const element = document.getElementById(`qrcode-${item.id}-${i}`);
        if (!element) return;

        // Clear previous QR only if you want to regenerate same cell
        element.innerHTML = "";

        const value = this.barcodeGenerateWith(item);
        if (value) {
          const qrcodeInstance = new window.QRCode(element, {
            text: String(value),
            width: parseFloat(this.barcodeWidth || 10) * 3.78,
            height: parseFloat(this.barcodeHeight || 10) * 3.78,
            correctLevel: window.QRCode.CorrectLevel.L,
          });
          element.qrcodeInstance = qrcodeInstance;
        }
      });
    },
    firstNonEmpty(...vals) {
      for (const v of vals) {
        if (v === null || v === undefined) continue;
        const s = String(v).trim();
        if (s.length) return s;
      }
      return null;
    },
    barcodeGenerateWith(item) {
      if (this.codeOption === "withId") {
        return this.firstNonEmpty(item.id, item.aksbrs_sfr);
      }
      if (this.codeOption === "withCode") {
        return this.firstNonEmpty(item.code, item["5"]);
      }
      if (this.codeOption === "withBarcode") {
        return this.firstNonEmpty(item.barcode, item["6"]);
      }
      return null;
    },
    handlePaperSizeChange(value) {
      if (value == "role") {
        this.paperWidth = 101.6;
        this.paperHeight = null;
        this.gapYBetweenLabels = null;
        this.gapXBetweenLabels = 2;
        this.columnCount = 2;
        this.spaceTop = null;
        this.spaceRight = null;
        this.spaceBottom = null;
        this.spaceLeft = null;
        this.labelHeight = 25.4;
        this.labelWidth = 48.8;
        this.gapBetweenLabelInfo = null;
        this.textSizeNameProduct = 8;
        this.textSizeProductPrice = 8;
        this.textSizeProductCode = 8;
        this.spaceInsideLeft = 1;
        this.spaceInsideBottom = 1;
        this.spaceInsideRight = 1;
        this.spaceInsideTop = 1;
        this.barcodeActive = null;
        this.barcodeOption = null;
        this.barcodeHeight = 34;
        this.barcodeWidth = null;
      }
      if (value == "a4") {
        this.paperWidth = 210;
        this.paperHeight = 297;
        this.gapYBetweenLabels = null;
        this.gapXBetweenLabels = null;
        this.columnCount = null;
        this.spaceTop = null;
        this.spaceRight = null;
        this.spaceBottom = null;
        this.spaceLeft = null;
        this.labelHeight = null;
        this.labelWidth = null;
        this.gapBetweenLabelInfo = null;
        this.textSizeNameProduct = 8;
        this.textSizeProductPrice = 8;
        this.textSizeProductCode = 8;
        this.spaceInsideLeft = null;
        this.spaceInsideBottom = null;
        this.spaceInsideRight = null;
        this.spaceInsideTop = null;
        this.barcodeActive = null;
        this.barcodeOption = null;
        this.barcodeHeight = null;
        this.barcodeWidth = null;
      }
      if (value == "a5") {
        this.paperWidth = 148;
        this.paperHeight = 210;
        this.gapYBetweenLabels = null;
        this.gapXBetweenLabels = null;
        this.columnCount = null;
        this.spaceTop = null;
        this.spaceRight = null;
        this.spaceBottom = null;
        this.spaceLeft = null;
        this.labelHeight = null;
        this.labelWidth = null;
        this.gapBetweenLabelInfo = null;
        this.textSizeNameProduct = 8;
        this.textSizeProductPrice = 8;
        this.textSizeProductCode = 8;
        this.spaceInsideLeft = null;
        this.spaceInsideBottom = null;
        this.spaceInsideRight = null;
        this.spaceInsideTop = null;
        this.barcodeActive = null;
        this.barcodeOption = null;
        this.barcodeHeight = null;
        this.barcodeWidth = null;
      }
      if (value == "custom") {
        this.paperWidth = null;
        this.paperHeight = null;
        this.gapYBetweenLabels = null;
        this.gapXBetweenLabels = null;
        this.columnCount = null;
        this.spaceTop = null;
        this.spaceRight = null;
        this.spaceBottom = null;
        this.spaceLeft = null;
        this.labelHeight = null;
        this.labelWidth = null;
        this.gapBetweenLabelInfo = null;
        this.textSizeNameProduct = 8;
        this.textSizeProductPrice = 8;
        this.textSizeProductCode = 8;
        this.spaceInsideLeft = null;
        this.spaceInsideBottom = null;
        this.spaceInsideRight = null;
        this.spaceInsideTop = null;
        this.barcodeActive = null;
        this.barcodeOption = null;
        this.barcodeHeight = null;
        this.barcodeWidth = null;
      }
    },
    print() {
      let direction = "ltr";
      if (this.$vuetify.rtl) {
        direction = "rtl";
      }

      const style = `
        <style>
          * {
            box-sizing: border-box;
          }

          ${
            this.$store.state.lang !== "fa"
              ? "body { font-family: arial !important; }"
              : ""
          }

          @page {
            size: ${this.paperWidth} ${this.labelHeight};
            margin: 0;
          }

          @media print {

            html, body {
              width: ${this.paperWidth};
              height: ${this.labelHeight};
            }
            /* strict background fff on lable*/
            .main-paper,
            .flex-wrapper,
            .flex-item {
              background: #fff !important;
              -webkit-print-color-adjust: economy;
              print-color-adjust: economy;
              color-adjust: economy;
            }
            .flex-item {
              width: ${this.labelWidth}mm !important;
              height: ${this.labelHeight}mm !important;
            }

          }

          table {
            border: none;
            border-collapse: collapse;
          }

          table td {
            border-left: 1px solid #c3c3c3;
          }

          table th {
            border-left: 1px solid #c3c3c3;
          }

          table td:first-child {
            border-right: 1px solid #c3c3c3;
          }

          table th:first-child {
            border-right: 1px solid #c3c3c3;
          }

          tbody > tr:last-child > td {
            border: 0;
          }

          thead > tr:first-child > th {
            border-top: 1px solid #c3c3c3;
          }

          @bottom-left {
            content: normal;
            margin: 3px;
          }
        </style>
      `;

      setTimeout(() => {
        // Get HTML to print from element
        const prtHtml = document.getElementById("print").innerHTML;

        // Collect all existing styles and link tags
        let stylesHtml = "";
        for (const node of document.querySelectorAll('link[rel="stylesheet"], style')) {
          stylesHtml += node.outerHTML;
        }

        // Create new print window
        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0"
        );

        WinPrint.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
            ${style}
          </head>
          <body style="direction: ${direction}">
            ${prtHtml}
          </body>
        </html>
      `);

        WinPrint.document.close();
        WinPrint.focus();

        setTimeout(() => {
          WinPrint.print();
          WinPrint.close();
        }, 2000);
      }, 50);
    },
    openUploadDialog() {
      this.snakbar = true;
      this.snakbarColor = "red";
      this.snakbarText = this.$t("attention to product stock");
      if (this.$root) {
        this.$root.$emit("open-user-file-process", { type: "barcode" });
      }
    },
    getItems(items) {
      var app = this;
      app.products = items.slice(1);
      app.filteredProducts = items.slice(1);
      setTimeout(function () {
        app.barcodeGenerate();
        app.QRCodeGenerate();
      }, 1000);
    },
  },
  created() {
    const savedItems = JSON.parse(localStorage.getItem("barcode-sizes"));
    this.hydratingItems = true;
    try {
      this.paperSize = savedItems.paperSize;
      this.paperWidth = savedItems.paperWidth;
      this.paperHeight = savedItems.paperHeight;
      this.gapYBetweenLabels = savedItems.gapYBetweenLabels;
      this.gapXBetweenLabels = savedItems.gapXBetweenLabels;
      this.columnCount = savedItems.columnCount;
      this.spaceTop = savedItems.spaceTop;
      this.spaceRight = savedItems.spaceRight;
      this.spaceBottom = savedItems.spaceBottom;
      this.spaceLeft = savedItems.spaceLeft;
      this.labelHeight = savedItems.labelHeight;
      this.labelWidth = savedItems.labelWidth;
      this.gapBetweenLabelInfo = savedItems.gapBetweenLabelInfo;
      this.textSizeNameProduct =
        savedItems?.textSizeNameProduct ?? savedItems?.textSize ?? 8;
      this.textSizeProductPrice = savedItems?.textSizeProductPrice ?? 8;
      this.textSizeProductCode = savedItems?.textSizeProductCode ?? 8;
      this.spaceInsideLeft = savedItems.spaceInsideLeft;
      this.spaceInsideBottom = savedItems.spaceInsideBottom;
      this.spaceInsideRight = savedItems.spaceInsideRight;
      this.spaceInsideTop = savedItems.spaceInsideTop;
      /* this.barcodeActive = savedItems.barcodeActive
      this.barcodeOption = savedItems.barcodeOption
      this.codeOption = savedItems.codeOption
      */
      this.barcodeHeight = savedItems.barcodeHeight;
      this.barcodeWidth = savedItems.barcodeWidth;
      this.selectedOptionPrice = savedItems.selectedOptionPrice;
      this.selectedOptionName = savedItems.selectedOptionName;
      this.selectedOptionCode = savedItems.selectedOptionCode;
      this.selectedNameVisual = savedItems.selectedNameVisual;
    } catch (e) {}
    this.$nextTick(() => {
      this.hydratingItems = false;
    });
  },
  mounted() {
    this.products = this.$route.params.items.map((p) => ({
      ...p,
      productStock: this.resolveStockValue(p),
    }));
    this.filteredProducts = [...this.products];

    // barcode
    const script = document.createElement("script");
    script.src = "https://abr.abriron.com/js/JsBarcode.all.min.js";
    script.onload = () => {
      console.log("JsBarcode loaded successfully");
      // Now JsBarcode is available
      this.barcodeGenerate();
    };
    script.onerror = () => {
      console.error("Failed to load JsBarcode");
    };
    document.head.appendChild(script);

    // QRCode
    const scriptQR = document.createElement("script");
    scriptQR.src = "https://cdn.jsdelivr.net/npm/qrcodejs2@0.0.2/qrcode.min.js";
    scriptQR.onload = () => {
      console.log("QRCode library loaded successfully");
      this.QRCodeGenerate();
    };
    scriptQR.onerror = () => {
      console.error("Failed to load QRCode library");
    };
    document.head.appendChild(scriptQR);
  },
  watch: {
    selectedStockStatus(val) {
      if (val) {
        this.products.forEach((p) => {
          p.productStock = this.resolveStockValue(p);
        });
        this.filteredProducts = [...this.products];
      }
    },
    selectedProducts(val) {
      if (val.length == this.products.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
    search(val) {
      if (!val) {
        this.filteredProducts = [...this.products];
        return;
      }
      const text = val.toString().toLowerCase().trim();
      this.filteredProducts = this.products.filter((p) => {
        return (
          (p.name && p.name.toLowerCase().includes(text)) ||
          (p.code && p.code.toLowerCase().includes(text)) ||
          (p.id && p.id.toString().includes(text))
        );
      });
    },
    formula() {
      this.formulaError = null;
    },
    barcodeOption(val) {
      if (val && val == "barcode" && this.barcodeActive) {
        if (this.products && this.products.length > 0) {
          this.barcodeGenerate();
        }
      }
      if (val && val == "QRcode" && this.barcodeActive) {
        if (this.products && this.products.length > 0) {
          this.QRCodeGenerate();
        }
      }
    },
    $data: {
      handler() {
        if (this.hydratingItems) return;
        localStorage.setItem("barcode-sizes", JSON.stringify(this.$data));
      },
      deep: true,
    },
    expandedProducts(val) {
      if (val) {
        // barcode
        const script = document.createElement("script");
        script.src = "https://abr.abriron.com/js/JsBarcode.all.min.js";
        script.onload = () => {
          console.log("JsBarcode loaded successfully");
          this.barcodeGenerate();
        };
        script.onerror = () => {
          console.error("Failed to load JsBarcode");
        };
        document.head.appendChild(script);

        // QRCode
        const scriptQR = document.createElement("script");
        scriptQR.src = "https://cdn.jsdelivr.net/npm/qrcodejs2@0.0.2/qrcode.min.js";
        scriptQR.onload = () => {
          console.log("QRCode library loaded successfully");
          this.QRCodeGenerate();
        };
        scriptQR.onerror = () => {
          console.error("Failed to load QRCode library");
        };
        document.head.appendChild(scriptQR);
      }
    },
    codeOption: {
      handler() {
        this.barcodeGenerate();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.v-card__text {
  width: auto !important;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
::v-deep .v-input--selection-controls .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-input__prepend-inner {
  position: absolute;
  top: 3px;
  right: 8px;
}
::v-deep .v-input--selection-controls {
  padding-top: 0;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls.v-input--checkbox {
  margin: 0 !important;
  padding: 0;
}
::v-deep .v-input--selection-controls__input .v-icon.v-icon {
  justify-content: flex-start;
}
::v-deep
  .v-text-field.count
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  direction: ltr;
}
::v-deep
  .v-text-field.count
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input,
::v-deep
  .v-text-field.setting-input.without-unit
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  text-align: center;
}
.products-item ::v-deep .custom-checkbox .v-input__control {
  margin-top: 8px;
}
.products-item .count ::v-deep .v-input__slot {
  width: 40px;
  height: 37px !important;
  margin-bottom: 0;
}
.search ::v-deep .v-input__slot {
  width: 170px;
}
.code-option ::v-deep .v-input__slot {
  width: 180px;
}
.wrapper {
  height: calc(100vh - 94px);
}
.wrapper .header {
  border-bottom: 1px solid silver;
  padding-bottom: 8px;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle-name-compact .child {
  padding: 5px;
}
.show-name-toggle .child {
  padding: 5px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.wrapper .footer {
  position: absolute;
  bottom: 0;
  border-top: 1px solid silver;
  height: 60px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: #fff;
}
.wrapper .products-list .products-item img {
  width: 40px;
  height: 38px;
  border-radius: 4px;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.products-list .wrapper {
  height: calc(100vh - 280px);
  overflow-y: auto;
  overflow-x: hidden;
}
.products-list .wrapper::-webkit-scrollbar {
  display: none;
}
.wrapper .wrapper-printer {
  background-color: #c0c0c03b;
  width: 100%;
  height: 100%;
  border-radius: 7px;
  border: 1px solid silver;
  height: calc(100vh - 183px);
  overflow-y: auto;
  overflow-x: hidden;
}
.wrapper .wrapper-printer::-webkit-scrollbar {
  display: none;
}
.wrapper .wrapper-printer .main-paper {
  background-color: #fff;
  border-radius: 5px;
}
.flex-wrapper {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: flex-start; */
}
.flex-item {
  flex: 0 0 auto;
  background: lightgray;
  display: flex;
  flex-direction: column;
}
.text-label {
  display: inline-block;
  max-width: 100%;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  max-height: 18px;
  vertical-align: middle;
}
.wrapper .wrapper-setting .setting-input ::v-deep .v-input__slot {
  width: 90px;
  margin-bottom: 0;
}
.wrapper .wrapper-setting .setting-input ::v-deep .v-input__prepend-outer {
  margin-top: 8px;
  margin-left: -27px;
}
.wrapper .wrapper-setting .setting-input.has-unit ::v-deep .v-input__slot {
  padding-right: 30px;
}
.wrapper .wrapper-setting .setting-input.has-unit.distance ::v-deep .v-input__slot {
  width: 75px;
}
.wrapper
  .wrapper-setting
  .show-name-controls
  .show-name-font-input
  ::v-deep
  .v-input__slot {
  width: 60px;
  min-height: 30px;
  height: 30px !important;
  margin-top: -5px;
}
.wrapper
  .wrapper-setting
  .show-name-controls
  .show-name-font-input
  ::v-deep
  .v-input__prepend-inner {
  top: 2px;
}
.wrapper .wrapper-setting .show-name-controls .show-name-font-input ::v-deep input {
  text-align: center;
  padding-top: 6px;
}
.show-price-toggle .child {
  padding: 5px;
}
.wrapper
  .wrapper-setting
  .show-price-controls
  .show-price-font-input
  ::v-deep
  .v-input__slot {
  width: 60px;
  min-height: 30px;
  height: 30px !important;
  margin-top: -5px;
}
.wrapper
  .wrapper-setting
  .show-price-controls
  .show-price-font-input
  ::v-deep
  .v-input__prepend-inner {
  top: 2px;
}
.wrapper .wrapper-setting .show-price-controls .show-price-font-input ::v-deep input {
  text-align: center;
  padding-top: 6px;
}
.show-code-toggle .child {
  padding: 5px;
}
.wrapper
  .wrapper-setting
  .show-code-controls
  .show-code-font-input
  ::v-deep
  .v-input__slot {
  width: 60px;
  min-height: 30px;
  height: 30px !important;
  margin-top: -5px;
}
.wrapper
  .wrapper-setting
  .show-code-controls
  .show-code-font-input
  ::v-deep
  .v-input__prepend-inner {
  top: 2px;
}
.wrapper .wrapper-setting .show-code-controls .show-code-font-input ::v-deep input {
  text-align: center;
  padding-top: 6px;
}
.v-list {
  padding: 0;
}
.v-list-item {
  padding: 5px;
  text-align: center;
  min-height: 27px;
  cursor: pointer;
}
.v-list-item .v-list-item__title {
  font-size: 13px;
}
.wrapper .wrapper-setting {
  overflow-y: auto;
  height: calc(100vh - 186px);
}
.wrapper .wrapper-setting::-webkit-scrollbar {
  display: none;
}
.v-icon.v-icon::after {
  display: none;
}
.calculator.v-btn:not(.v-btn--round).v-size--default {
  height: 34px;
  min-width: 0;
  width: 37px;
}
</style>
